import { Outlet } from 'react-router-dom';

import Header from '@components/Header/Header';
import { HEADER_HEIGHT } from '@components/Header/HeaderStyles';
import Onboarding from '@components/Onboarding/Onboarding';
import Sidebar from '@components/sidebar/Sidebar';
import { SIDEBAR_WIDTH } from '@components/sidebar/SidebarStyles';
import { Stack } from '@mui/material';

import { CalendarConnectionStatusDtoStatus } from '@/api/generated';
import PopupError from '@/components/Integrations/components/PopupError';
import useCalendarConnectionStatus from '@/hooks/useCalendarConnectionStatus';

const Layout = () => {
  const calendarConnectionStatus = useCalendarConnectionStatus();

  if (calendarConnectionStatus === CalendarConnectionStatusDtoStatus.DISCONNECTED) {
    return <Onboarding status={calendarConnectionStatus} />;
  }

  if (calendarConnectionStatus === CalendarConnectionStatusDtoStatus.NOT_CONNECTED) {
    return <Onboarding status={calendarConnectionStatus} />;
  }

  if (calendarConnectionStatus === CalendarConnectionStatusDtoStatus.CONNECTED) {
    return (
      <Stack height="100%" width="100%">
        <PopupError />
        <Header />
        <Stack
          sx={{
            paddingLeft: {
              xs: 0,
              md: SIDEBAR_WIDTH,
              lg: SIDEBAR_WIDTH
            },
            height: '100%',
            paddingTop: HEADER_HEIGHT,
            flexDirection: 'row',
            position: 'relative',
            width: '100%'
          }}
        >
          <Sidebar />
          <Stack flex={1} width="100%" height="100%">
            <Outlet />
          </Stack>
        </Stack>
      </Stack>
    );
  }
  return null;
};
export default Layout;
